import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Typography,
  Paper,
  Snackbar,
  CircularProgress,
  InputAdornment,
  IconButton
} from '@mui/material';
import {
  Email as EmailIcon,
  VpnKey as VpnKeyIcon,
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon
} from '@mui/icons-material';
import { useNavigate, useParams } from 'react-router-dom';
import { resetPassword } from '../../Conections/LogConections';


export default function ResetPassword() {

  const params = useParams();
  const goTo = useNavigate();

  const [email, setEmail] = useState('');
  const [token, setToken] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');

  React.useEffect(() => {
    setToken(params.token);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !token || !newPassword || !confirmPassword) {
      setSnackbarMessage('Por favor, complete todos los campos.');
      setOpenSnackbar(true);
      return;
    }

    if (newPassword !== confirmPassword) {
      setSnackbarMessage('Las contraseñas no coinciden.');
      setOpenSnackbar(true);
      return;
    }

    setIsLoading(true);

    // Simulamos una llamada a la API
    try {
      const datos = await resetPassword(email, token, newPassword, confirmPassword);
      if (typeof datos[0] === "number") {
        setSnackbarMessage('Hubo un error al restablecer su contraseña. Por favor, intente nuevamente.');
        setOpenSnackbar(true);
      } else {
        setSnackbarMessage('Su contraseña ha sido restablecida con éxito.');
        setOpenSnackbar(true);
        setEmail('');
        setToken('');
        setNewPassword('');
        setConfirmPassword('');
        goTo("/login");
      }
    } catch (error) {
      setSnackbarMessage('Hubo un error al restablecer su contraseña. Por favor, intente nuevamente.');
      setOpenSnackbar(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleTogglePasswordVisibility = (field) => {
    if (field === 'newPassword') {
      setShowPassword(!showPassword);
    } else {
      setShowConfirmPassword(!showConfirmPassword);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: 'background.default'
      }}
    >
      <Paper elevation={3} sx={{ p: 4, maxWidth: 400, width: '100%' }}>
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <Typography component="h1" variant="h5" align="center" gutterBottom>
            Restablecer Contraseña
          </Typography>
          <Typography variant="body2" align="center" sx={{ mb: 3 }}>
            Ingrese el token recibido por correo electrónico, su dirección de correo y la nueva contraseña.
          </Typography>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Correo Electrónico"
            name="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            InputProps={{
              startAdornment: <EmailIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />,
            }}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            id="token"
            label="Token"
            name="token"
            value={token}
            onChange={(e) => setToken(e.target.value)}
            InputProps={{
              startAdornment: <VpnKeyIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />,
            }}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="newPassword"
            label="Nueva Contraseña"
            type={showPassword ? 'text' : 'password'}
            id="newPassword"
            autoComplete="new-password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => handleTogglePasswordVisibility('newPassword')}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="confirmPassword"
            label="Confirmar Nueva Contraseña"
            type={showConfirmPassword ? 'text' : 'password'}
            id="confirmPassword"
            autoComplete="new-password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle confirm password visibility"
                    onClick={() => handleTogglePasswordVisibility('confirmPassword')}
                    edge="end"
                  >
                    {showConfirmPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            disabled={isLoading}
          >
            {isLoading ? <CircularProgress size={24} /> : 'Restablecer Contraseña'}
          </Button>
        </Box>
      </Paper>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={() => setOpenSnackbar(false)}
        message={snackbarMessage}
      />
    </Box>
  );
}